<template>
  <div id="app">
    <app-header v-if="header_show"></app-header>
    <router-view v-on:header="header" v-on:footer="footer"></router-view>
    <app-footer v-if="footer_show"></app-footer>
  </div>
</template>

<script>
import header from './components/include/top'
import footer from './components/include/foot'
export default {

  name: 'App',
  data(){
      return {
          header_show:true,
          footer_show:true,
      }
  },
  components: {
        'app-header':header,
        'app-footer':footer,
  },
  methods:{
      //是否显示头部
      header:function (bool) {
        this.header_show = bool;
      },
      //是否显示底部
      footer:function (bool) {
          this.footer_show = bool;
      }
}
}
</script>

<style >

</style>


// WEBPACK FOOTER //
// src/App.vue